
import { HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { BehaviorSubject, Observable } from 'rxjs';
import { ApiGateway, Breed } from 'cw-backend';
import { SnackBarService } from 'cw-utils';

@Injectable()
export class BreedEditProvider implements Resolve<any>
{
    routeParams: any;
    state: any;
    onDataChanged: BehaviorSubject<any>;
    breed: Breed;

    constructor(
        public gw: ApiGateway,
        public snackBar: SnackBarService
    ) {
        this.onDataChanged = new BehaviorSubject({});
    }

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> | Promise<any> | any {
        this.routeParams = route.params;

        return new Promise<void>((resolve, reject) => {
            Promise.all([this.getBreed()]).then(
                () => {
                    resolve();
                },
                reject
            );
        });
    }

    getBreed(): Promise<any> {
        return new Promise((resolve, reject) => {
            let data =  this.checkLastModifications()
            if (data && data.id == this.routeParams.id) {
                this.breed = data;
                this.onDataChanged.next(this.breed);
                resolve(this.breed);
            } else if (this.routeParams.id === 'novo') {
                this.onDataChanged.next(false);
                resolve(false);
            }
            else {
                this.gw.get('breed/' + this.routeParams.id).subscribe((res: Breed ) => {
                    this.breed = res;
                    this.onDataChanged.next(this.breed);
                    resolve(res);
                }, reject);
            }
        });
    }

    insert(breed): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.post('breed/', breed).subscribe((response: HttpResponse<any>) => {
                resolve(response);
                this.snackBar.successMessage(response.body.message);
            }, reject);
        });
    }

    edit(breed): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.put('breed/', breed).subscribe((response: HttpResponse<any>) => {
                resolve(response);
                this.snackBar.successMessage(response.body.message);
            }, reject);
        });
    }

    delete(breed): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.delete('breed/' + breed.id).subscribe((response: HttpResponse<any>) => {
                resolve(response);
                 this.snackBar.successMessage(response.body.message);
            }, reject);
        });
    }

    checkLastModifications(): Breed {
        let wasLocked = JSON.parse(localStorage.getItem('session_locked'));
        let data;
        if (wasLocked){
            data = JSON.parse(localStorage.getItem('last_modification'));
            localStorage.removeItem('session_locked');
        }  
        return data;
    }
}
